
import { Component, Vue } from 'vue-property-decorator';
import { EscalationInterface, EscalationRepositoryInterface } from '../../../../services/QA/escalation/interfaces';

import TagRepositoryInterface, { TagInterface } from '../../../../services/QA/tag/interfaces';
import ScoreTypeRepositoryInterface, { ScoreTypeInterface } from '../../../../services/QA/scoreType/interfaces';
import ScoreGradeRepositoryInterface, { ScoreGradeInterface } from '../../../../services/QA/scoreGrade/interfaces';
import { UserHasScopes } from '../../../middleware/Route/Auth';
import { Roles } from '@/services/Roles';
import NoteRepositoryInterface, {
  NoteInterface,
  TicketNoteInterface,
} from '../../../../services/QA/note/interfaces';
import { UserBaseInfoInterface, UserRepoInterface } from '../../../../services/Users/Interfaces';
import CommentRepositoryInterface, {
  CommentInterface, TicketCommentInterface, TicketReplyCommentInterface,
} from '../../../../services/QA/comment/interfaces';
import { EscalationStatus } from '@/services/QA/escalation';
import Themeable from 'vuetify/lib/mixins/themeable';
import EscalateDialog from '../../../../components/dialogs/qa/escalation/EscalateDialog.vue';
import ChatMessageImageDialog from '../../../../components/dialogs/qa/chat/ChatMessageImageDialog.vue';
import FeedbackDialog from '../../../../components/dialogs/qa/feedback/FeedbackDialog.vue';
import DeleteCommentDialog from '../../../../components/dialogs/qa/comment/DeleteCommentDialog.vue';
import TicketRepositoryInterface, {
  TicketInterface, TicketPriorities,
  TicketScoreInterface,
  TicketWSMessageInterface,
} from '../../../../services/QA/ticket/interfaces';
import DeleteNoteDialog from '@/components/dialogs/qa/note/DeleteNoteDialog.vue';
import EditCommentDialog from '@/components/dialogs/qa/comment/EditCommentDialog.vue';
import EditNoteDialog from '@/components/dialogs/qa/note/EditNoteDialog.vue';
import { ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'escalationRepository',
    'scoreGradeRepository',
    'scoreTypeRepository',
    'ticketRepository',
    'tagRepository',
    'noteRepository',
    'commentRepository',
    'userRepository',
    'profileRepository',
  ],
  components: {
    EscalateDialog,
    ChatMessageImageDialog,
    FeedbackDialog,
    DeleteCommentDialog,
    DeleteNoteDialog,
    EditCommentDialog,
    EditNoteDialog,
  },
  sockets: {
    ticketData(msg: TicketWSMessageInterface): void {
      this.$emit('updateTicketData', msg.ticket);
    },
    newTicketComment(msg: { ticketComment: TicketCommentInterface }): void {
      this.$emit('updateTicketComments', msg.ticketComment);
    },
    newTicketReplyComment(msg: { replyComment: TicketReplyCommentInterface }): void {
      this.$emit('updateTicketReplyComments', msg.replyComment);
    },
    newTicketPrivateNote(msg: { ticketNote: TicketNoteInterface }): void {
      this.$emit('updateTicketNotes', msg.ticketNote);
    },
    updatedComment(msg: { comment: CommentInterface }): void {
      this.$emit('updatedCommentMessage', msg.comment);
    },
    updatedNote(msg: { note: NoteInterface }): void {
      this.$emit('updatedNoteMessage', msg.note);
    },
  },
})
export default class TicketEscalation extends Vue {
  private escalation!: EscalationInterface;
  private ticket: TicketInterface = {} as TicketInterface;
  private ticketData: TicketInterface = {} as TicketInterface;
  private loading: boolean = true;
  private valid: boolean = false;
  private tags: TagInterface[] = [];
  private tagsSelected: number[] = [];
  private scoreTypes: ScoreTypeInterface[] = [];
  private scoreGrades: ScoreGradeInterface[] = [];
  private comment: string = '';
  private privateNote: string = '';
  private ticketComment: string = '';
  private replyComment: string = '';
  private scores: { [scoreTypeId: number]: number } = {};
  private scoresSelected: unknown[] = [];
  private height: number = 0;
  private userHasScopes: object = UserHasScopes;
  private userRoles: object = Roles;
  private searchTag: string = '';


  private escalationRepository!: EscalationRepositoryInterface;
  private scoreTypeRepository!: ScoreTypeRepositoryInterface;
  private scoreGradeRepository!: ScoreGradeRepositoryInterface;
  private ticketRepository!: TicketRepositoryInterface;
  private tagRepository!: TagRepositoryInterface;
  private noteRepository!: NoteRepositoryInterface;
  private userRepository!: UserRepoInterface;
  private profileRepository!: ProfileRepositoryInterface;
  private commentRepository!: CommentRepositoryInterface;
  private usersMap: { [userId: string]: UserBaseInfoInterface } = {};

  private messageReceived: boolean = false;
  private responseReceived: boolean = false;

  private urlForDialog: string | false = false;
  private imageDialog: string = '';
  private escalateDialog: string = '';
  private feedbackDialog: string = '';
  private commentIdForDialog: number = 0;
  private deleteCommentDialog: string | false = false;
  private deletedScores: TicketScoreInterface[] = [];

  private noteIdForDialog: number = 0;
  private deleteNoteDialog: string | false = false;
  private commentIdForEditDialog: number = 0;
  private commentContentForDialog: string = '';
  private editCommentDialog: string | false = false;
  private noteIdForEditDialog: number = 0;
  private noteContentForDialog: string = '';
  private editNoteDialog: string | false = false;

  private ticketPriorities: Array<string | TicketPriorities>;


  public async beforeCreate(): Promise<void> {
    this.ticketPriorities = Object.values(TicketPriorities);
    this.$on('updateTicketData', async (ticket: TicketInterface) => {
      await this.getUsersInfoByEmails(ticket);
      this.messageReceived = true;
      this.mergeTicketProperties(ticket);
    });

    this.$on('updateTicketComments', (ticketComment: TicketCommentInterface) => {

      if (ticketComment.ticketId !== this.ticket.id) {
        return;
      }

      this.ticket.comments.push(ticketComment);
      this.ticket.comments = this.ticket.comments.sort((a, b) => a.comment.timestamp - b.comment.timestamp);
      this.$forceUpdate();
    });

    this.$on('updateTicketNotes', (ticketNote: TicketNoteInterface) => {

      if (ticketNote.ticketId !== this.ticket.id) {
        return;
      }

      this.ticket.notes.push(ticketNote);
      this.ticket.notes = this.ticket.notes.sort((a, b) => a.note.timestamp - b.note.timestamp);
      this.$forceUpdate();
    });

    this.$on('updateTicketReplyComments', (replyComment: TicketReplyCommentInterface) => {
      this.ticket.replies.forEach((reply) => {
        if (reply.id !== replyComment.replyId) {
          return;
        }

        reply.comments.push(replyComment);
        reply.comments = reply.comments.sort((a, b) => a.comment.timestamp - b.comment.timestamp);
      });

      this.$forceUpdate();
    });

    this.$on('updatedCommentMessage', (comment: CommentInterface) => {
      let commentIndex = this.ticket.comments.findIndex((ticketComment) => ticketComment.comment.id === comment.id);

      if (commentIndex !== -1) {
        this.ticket.comments[commentIndex].comment = comment;
      } else {
        let messageIndex = -1;

        this.ticket.replies.forEach((replay, mi) => {
          replay.comments.forEach((replyComment, ci) => {
            if (replyComment.comment.id === comment.id) {
              messageIndex = mi;
              commentIndex = ci;
            }
          });
        });

        if (messageIndex !== -1 && commentIndex !== -1) {
          this.ticket.replies[messageIndex].comments[commentIndex].comment = comment;
        }
      }

      this.$forceUpdate();
    });

    this.$on('updatedNoteMessage', (note: NoteInterface) => {
      const noteIndex = this.ticket.notes.findIndex((ticketNote) => ticketNote.note.id === note.id);

      if (noteIndex !== -1) {
        this.ticket.notes[noteIndex].note = note;
      }

      this.$forceUpdate();
    });
  }

  public async created(): Promise<void> {
    await this.initialize();
    // @ts-ignore
    this.height = this.$parent.$el.offsetHeight;
  }

  public async initialize(): Promise<void> {
    try {
      this.tags = await this.tagRepository.getActiveTags();
      this.scoreTypes = await this.scoreTypeRepository.getAllScoreTypes();
      this.scoreGrades = await this.scoreGradeRepository.getAllScoreGrades();
      const escalationId = Number(this.$route.params.escalationId);
      const escalation = await this.escalationRepository.getEscalation(escalationId);
      await this.getUsersInfoByEscalationData(escalation.escalation);
      const ticket = escalation.ticket;
      this.escalation = escalation.escalation;


      ticket.replies.map((reply) => {
        reply.commentInputVisible = false;
        return reply;
      });

      ticket.scores.forEach((ticketScore) => {
        if (!ticketScore.score.deletedAt) {
          this.scores[ticketScore.score.type.id] = ticketScore.score.grade.id;
        } else {
          this.deletedScores.push(ticketScore);
        }
      });

      this.valid = Object.keys(this.scores).length === this.scoreTypes.length;
      this.tagsSelected = ticket.tags.map((tag) => tag.id);

      await this.getUsersInfoByIds(ticket);
      this.responseReceived = true;
      this.ticket = ticket;
    } catch (e) {
      console.log(e);
      this.$errorDialog.show(e.response?.data?.message);
      await this.$router.push({ path: '/qc/escalations' });
    }
  }

  private addScore(scoreTypeId: number, scoreGradeId: number): void {
    this.scores[scoreTypeId] = scoreGradeId;
    this.valid = Object.keys(this.scores).length === this.scoreTypes.length;
  }

  private removeScore(scoreTypeId: number): void {
    delete this.scores[scoreTypeId];
    this.valid = Object.keys(this.scores).length === this.scoreTypes.length;
  }

  private async reviewEscalation(): Promise<void> {
    try {
      await this.escalationRepository.reviewEscalation(
        this.escalation.id,
        this.ticket.agents.filter((agent) => agent.id).map((agent) => agent.id),
        this.scores,
        this.tagsSelected,
        undefined,
        this.ticket.id,
      );
      this.escalation.status = EscalationStatus.REVIEWED;
      this.$successDialog.show('Review Success!');
      await this.initialize();
    } catch (e) {
      console.log(e);
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private async deleteComment(commentId: number): Promise<void> {
    this.commentIdForDialog = commentId;
    this.deleteCommentDialog = 'delete-comment-dialog';
  }

  private removeComment(commentId: number): void {
    let commentIndex = this.ticket.comments.findIndex((chatComment) => chatComment.comment.id === commentId);

    if (commentIndex !== -1) {
      delete this.ticket.comments[commentIndex];
      this.ticket.comments = this.ticket.comments.filter((comment) => !!comment);
    } else {
      let replyIndex = -1;

      this.ticket.replies.forEach((reply, ri) => {
        if (reply.comments) {
          reply.comments.forEach((messageComment, ci) => {
            if (messageComment.comment.id === commentId) {
              replyIndex = ri;
              commentIndex = ci;
            }
          });
        }
      });

      delete this.ticket.replies[replyIndex].comments[commentIndex];
      this.ticket.replies[replyIndex].comments = this.ticket.replies[replyIndex]
        .comments.filter((comment) => !!comment);
    }

    this.$forceUpdate();
  }

  private async prepareCommentForEdit(commentId: number): Promise<void> {
    let commentIndex = this.ticket.comments.findIndex((ticketComment) => ticketComment.comment.id === commentId);
    if (commentIndex !== -1) {
      this.commentIdForEditDialog = this.ticket.comments[commentIndex].comment.id;
      this.commentContentForDialog = this.ticket.comments[commentIndex].comment.content;
      this.editCommentDialog = 'edit-comment-dialog';
    } else {
      let replyIndex = -1;

      this.ticket.replies.forEach((reply, mi) => {
        reply.comments.forEach((replyComment, ci) => {
          if (replyComment.comment.id === commentId) {
            replyIndex = mi;
            commentIndex = ci;
          }
        });
      });

      this.commentIdForEditDialog = this.ticket.replies[replyIndex].comments[commentIndex].comment.id;
      this.commentContentForDialog = this.ticket.replies[replyIndex].comments[commentIndex].comment.content;
      this.editCommentDialog = 'edit-comment-dialog';
    }
  }

  private async editComment(commentId: number, content: string): Promise<void> {
    let commentIndex = this.ticket.comments.findIndex((ticketComment) => ticketComment.comment.id === commentId);
    if (commentIndex !== -1) {
      this.ticket.comments[commentIndex].comment.content = content;
      this.ticket.comments[commentIndex].comment.updatedAt = Math.floor(Date.now() / 1000);
    } else {
      let replyIndex = -1;

      this.ticket.replies.forEach((reply, mi) => {
        reply.comments.forEach((replyComment, ci) => {
          if (replyComment.comment.id === commentId) {
            replyIndex = mi;
            commentIndex = ci;
          }
        });
      });

      this.ticket.replies[replyIndex].comments[commentIndex].comment.content = content;
      this.ticket.replies[replyIndex].comments[commentIndex].comment.updatedAt = Math.floor(Date.now() / 1000);
    }
  }

  private async prepareNoteForEdit(noteId: number): Promise<void> {
    const noteIndex = this.ticket.notes.findIndex((ticketNote) => ticketNote.note.id === noteId);
    if (noteIndex !== -1) {
      this.noteIdForEditDialog = this.ticket.notes[noteIndex].note.id;
      this.noteContentForDialog = this.ticket.notes[noteIndex].note.content;
      this.editNoteDialog = 'edit-note-dialog';
    }
  }

  private async editNote(noteId: number, content: string): Promise<void> {
    const noteIndex = this.ticket.notes.findIndex((ticketNote) => ticketNote.note.id === noteId);
    if (noteIndex !== -1) {
      this.ticket.notes[noteIndex].note.content = content;
      this.ticket.notes[noteIndex].note.updatedAt = Math.floor(Date.now() / 1000);
    }
  }

  private removeNote(noteId: number): void {
    const noteIndex = this.ticket.notes.findIndex((ticketNote) => ticketNote.note.id === noteId);

    if (noteIndex !== -1) {
      delete this.ticket.notes[noteIndex];
      this.ticket.notes = this.ticket.notes.filter((note) => !!note);
    }

    this.$forceUpdate();
  }

  private async deleteNote(noteId: number): Promise<void> {
    this.noteIdForDialog = noteId;
    this.deleteNoteDialog = 'delete-note-dialog';
  }

  private async feedback(): Promise<void> {
    this.feedbackDialog = 'feedback-dialog';
  }

  private async addComment(): Promise<void> {
    try {
      const commentDTO: Partial<CommentInterface> = {
        content: this.comment,
        authorId: this.$store.getters.id,
        timestamp: Math.floor(Date.now() / 1000),
      };

      await this.commentRepository.addTicketComment(this.ticket.id, commentDTO, true);
      this.comment = '';

      if (this.escalation.status !== EscalationStatus.IN_PROGRESS) {
        this.escalation.status = EscalationStatus.IN_PROGRESS;
        await this.escalationRepository.changeEscalationStatus(this.escalation.id, EscalationStatus.IN_PROGRESS);
      }

    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message);
    }
  }

  private async addNote(): Promise<void> {
    try {
      const note: Partial<NoteInterface> = {
        content: this.privateNote,
        authorId: this.$store.getters.id,
        timestamp: Math.floor(Date.now() / 1000),
      };

      await this.noteRepository.addTicketNote(this.ticket.id, note, true);
      this.privateNote = '';

      if (this.escalation.status !== EscalationStatus.IN_PROGRESS) {
        this.escalation.status = EscalationStatus.IN_PROGRESS;
        await this.escalationRepository.changeEscalationStatus(this.escalation.id, EscalationStatus.IN_PROGRESS);
      }

    } catch (err) {
      console.log(err);
      this.$errorDialog.show(err.response?.data?.message);
    }
  }

  private async addCommentToReply(replyId: number): Promise<void> {
    try {
      const comment: Partial<CommentInterface> = {
        content: this.replyComment,
        authorId: this.$store.getters.id,
        timestamp: Math.floor(Date.now() / 1000),
      };

      await this.commentRepository.addReplyComment(this.ticket.id, replyId, comment, true);
      this.replyComment = '';

      if (this.escalation.status !== EscalationStatus.IN_PROGRESS) {
        this.escalation.status = EscalationStatus.IN_PROGRESS;
        await this.escalationRepository.changeEscalationStatus(this.escalation.id, EscalationStatus.IN_PROGRESS);
      }
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message);
    }
  }

  private mergeTicketProperties(ticketData: TicketInterface): void {
    if (!this.responseReceived) {
      setTimeout(() => this.mergeTicketProperties(ticketData), 200);
      return;
    }

    if (ticketData.id !== this.ticket.id) {
      this.messageReceived = false;
      return;
    }

    Object.getOwnPropertyNames(ticketData).forEach((property: string) => {
      if (!this.ticket[property]) {
        this.ticket[property] = ticketData[property];
      } else if (Array.isArray(ticketData[property])) {
        (ticketData[property] as []).forEach((ticketDataArrItem: { id: number }) => {
          const index = (this.ticket[property] as [])
            .findIndex((value: { id: number }) => value.id === ticketDataArrItem.id);

          if (index !== -1) {
            Object.assign((this.ticket[property] as [])[index], ticketDataArrItem);
          } else {
            (this.ticket[property] as unknown[]).push(ticketDataArrItem);
          }
        });
      }
    });

    this.ticket.replies = this.ticket.replies.sort((replyA, replyB) => replyA.date.localeCompare(replyB.date));
    this.loading = !(this.responseReceived && this.messageReceived);
    this.$forceUpdate();
  }

  private showCommentArea(replyId: number): void {
    const index = this.ticket.replies.findIndex((reply) => reply.id === replyId);
    this.ticket.replies.forEach((message, i) => {
      if (i !== index) {
        message.commentInputVisible = false;
      }
    });
    this.ticket.replies[index].commentInputVisible = !this.ticket.replies[index].commentInputVisible;
    this.$forceUpdate();
  }

  private async createTag(): Promise<void> {
    if (!this.searchTag) {
      return;
    }

    const newTag = await this.tagRepository.createTag({
      label: this.searchTag,
      color: '#808080FF',
    });

    this.tags.push(newTag);
    // @ts-ignore
    this.tagsSelected.push(newTag);
  }

  private async closeReview(): Promise<void> {
    await this.$router.back();
  }

  private async getUsersInfoByEscalationData(escalation: EscalationInterface): Promise<void> {
    const usersIds: string[] = [];

    if (usersIds.indexOf(escalation.escalatedFromUserId) === -1) {
      usersIds.push(escalation.escalatedFromUserId);
    }

    if (usersIds.indexOf(escalation.departmentManager) === -1) {
      usersIds.push(escalation.departmentManager);
    }

    const users = await this.userRepository.getUsersByIds(usersIds);
    users.forEach((user) => {
      this.usersMap[user.id] = user;
    });
  }

  private async getUsersInfoByIds(ticket: TicketInterface): Promise<void> {
    const usersIds: string[] = [];

    ticket.comments.forEach((ticketComment) => {
      if (usersIds.indexOf(ticketComment.comment.authorId) === -1) {
        usersIds.push(ticketComment.comment.authorId);
      }
    });

    ticket.notes.forEach((ticketNote) => {
      if (usersIds.indexOf(ticketNote.note.authorId) === -1) {
        usersIds.push(ticketNote.note.authorId);
      }
    });

    ticket.replies.forEach((reply) => {
      if (!reply.comments.length) {
        return;
      }

      reply.comments.forEach((comment) => {
        if (usersIds.indexOf(comment.comment.authorId) === -1) {
          usersIds.push(comment.comment.authorId);
        }
      });
    });

    const users = await this.userRepository.getUsersByIds(usersIds);
    users.forEach((user) => {
      this.usersMap[user.id] = user;
    });
  }

  private async getUsersInfoByEmails(ticket: TicketInterface): Promise<void> {
    ticket.agents = ticket.agents.filter((agent) => !!agent.email);
    const usersEmails: string[] = [];
    ticket.agents.forEach((agent) => {
      if (usersEmails.indexOf(agent.email) === -1) {
        usersEmails.push(agent.email);
      }
    });

    const users = await this.userRepository.getUsersByEmails(usersEmails);
    const profiles = await this.profileRepository.getBaseProfileDataByUsersIds(
      users.map((user) => user.id),
    );

    users.forEach((user) => {
      const profileIndex = profiles.findIndex((profile) => profile.userId === String(user.id));

      if (profileIndex === -1) {
        return;
      }

      this.usersMap[user.id] = user;
      const index = ticket.agents.findIndex((agent) => agent.email === user.email);
      if (index !== -1) {
        ticket.agents[index].id = user.id;
        ticket.agents[index].fullName =
          `${profiles[profileIndex].firstName} ${profiles[profileIndex].lastName}`;
      }
    });
  }
}
